import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function Poll({ v }) {
  if (!v.showPoll) return null;
  return (
    <>
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.closePoll}>
        <div className="gp-venster" onClick={v.stopProp} style={{ "width": "min(560px,100%)", "maxHeight": "calc(100vh - 80px)", "overflowY": "auto", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "18px" }}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px", "flex": "0 0 auto" }}>
            <span style={{ "display": "flex", "alignItems": "center", "justifyContent": "center", "width": "38px", "height": "38px", "borderRadius": "12px", "border": "3px solid var(--ink)", "background": "var(--geel)", "flex": "0 0 auto" }}>
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 20V10" />
                <path d="M12 20V4" />
                <path d="M18 20v-6" />
              </svg>
            </span>
            <div style={{ "fontSize": "19px", "fontWeight": "700", "flex": "1 1 auto" }}>
              Poll
            </div>
            <button onClick={v.closePoll} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={20} />
            </button>
          </div>
          <div style={{ "fontSize": "20px", "fontWeight": "700", "lineHeight": "1.4", "textWrap": "pretty" }}>
            <Interp v={v.pollQuestion} />
          </div>
          {v.pollNotVoted ? (<>
            <div style={{ "display": "flex", "gap": "14px", "flexWrap": "wrap" }}>
              {toList(v.pollChoices).map((o, $index) => (
                <React.Fragment key={$index}>
                  <button onClick={o?.onVote} className="gp-btn" style={css(o?.cardStyle)}>
                    {' '}
                    {o?.hasImg ? (<>
                      {' '}
                      <img alt="" src={o?.imgUrl} style={{ "width": "128px", "height": "128px", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "#fff", "display": "block", "objectFit": "cover" }} />
                      {' '}
                    </>) : null}
                    {' '}
                    <span style={css(o?.letterStyle)}>
                      <Interp v={o?.letter} />
                    </span>
                    {' '}
                    <span style={{ "fontSize": "16px", "fontWeight": "700", "textAlign": "center", "lineHeight": "1.4", "textWrap": "pretty" }}>
                      <Interp v={o?.label} />
                    </span>
                    {' '}
                  </button>
                </React.Fragment>
              ))}
            </div>
          </>) : null}
          {v.pollVoted ? (<>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "16px" }}>
              {toList(v.pollResults).map((o, $index) => (
                <React.Fragment key={$index}>
                  <div style={{ "display": "flex", "alignItems": "center", "gap": "12px" }}>
                    {o?.hasImg ? (<>
                      <img alt="" src={o?.imgUrl} style={{ "width": "64px", "height": "64px", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "#fff", "display": "block", "objectFit": "cover", "flex": "0 0 auto" }} />
                    </>) : null}
                    <span style={css(o?.letterStyle)}>
                      <Interp v={o?.letter} />
                    </span>
                    <div style={{ "flex": "1 1 auto", "minWidth": "0", "display": "flex", "flexDirection": "column", "gap": "6px" }}>
                      <div style={{ "display": "flex", "alignItems": "center", "gap": "8px" }}>
                        <span style={{ "fontSize": "15px", "fontWeight": "700", "flex": "1 1 auto", "minWidth": "0", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                          <Interp v={o?.label} />
                        </span>
                        {o?.isMine ? (<>
                          <span style={{ "flex": "0 0 auto", "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "#fff", "background": "var(--paars)", "border": "2px solid var(--ink)", "borderRadius": "999px", "padding": "2px 8px" }}>
                            jouw stem
                          </span>
                        </>) : null}
                        <span style={{ "flex": "0 0 auto", "fontSize": "14px", "fontWeight": "700", "color": "var(--tekst-2)" }}>
                          <Interp v={o?.votesLabel} />
                        </span>
                      </div>
                      <div style={{ "height": "24px", "border": "3px solid var(--ink)", "borderRadius": "999px", "background": "var(--lila)", "overflow": "hidden" }}>
                        {' '}
                        <div style={css(o?.barStyle)} />
                        {' '}
                      </div>
                      {/* Wie hierop stemde. Uit de ideeënbus: je zag hoeveel stemmen
                          er waren, maar niet van wie. Klik op een kop en je gaat naar
                          dat profiel. */}
                      {o?.heeftStemmers ? (
                        <div style={css(v.pollStemmersRijStyle)} title={o?.stemmersTitel}>
                          <span style={css(v.pollStemmersKoppenStyle)}>
                            {toList(o?.stemmers).map((s, $i) => (
                              <React.Fragment key={$i}>
                                <img alt="" src={s?.avatarUrl} title={s?.name} onClick={s?.onOpen} style={css(s?.style)} />
                              </React.Fragment>
                            ))}
                          </span>
                          {o?.heeftRest ? (
                            <span style={css(v.pollRestStyle)}><Interp v={o?.restLabel} /></span>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </React.Fragment>
              ))}
              <div style={{ "fontSize": "12px", "fontWeight": "600", "color": "var(--tekst-3)" }}>
                <Interp v={v.pollTotalLabel} />
              </div>
            </div>
          </>) : null}
          {v.hasPollError ? (<>
            <div style={{ "fontSize": "13px", "color": "var(--fout)", "fontWeight": "600" }}>
              <Interp v={v.pollError} />
            </div>
          </>) : null}
          <button onClick={v.closePoll} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
            Ik denk er nog even over na…
          </button>
        </div>
      </div>
    </>
  );
}
